import { Packet } from "../Interfaces/commonDtos";
import { ISettingDTO } from "../Interfaces/setting";
import { getRequest, postRequest } from "./requestTemplates";

export const getExeConfig = (): Promise<ISettingDTO> =>
  getRequest("/v1/setting/getExeConfig");
export const setExeConfig = (dto: ISettingDTO): Promise<Packet<boolean>> =>
  postRequest("/v1/setting/setExeConfig", dto);
